import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/adminApi";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sid = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id: sid });
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user: r.data } });
      } catch (e) {
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", {
          replace: true,
          state: { authError: e?.response?.data?.detail || "Sign-in failed. Please try again." },
        });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-callback">
      <div className="text-[11px] uppercase tracking-[0.3em] text-foreground/60">
        Signing you in…
      </div>
    </div>
  );
}
